import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import './Spinner.scss';

const Spinner = props => {
  let btnSize = 15;

  const color = props.color || 'primary';

  if (props.size !== null) {
    if (props.size === 'sm') {
      btnSize = 15;
    } else if (props.size === 'md') {
      btnSize = 42;
    } else if (props.size === 'lg') {
      btnSize = 80;
    } else {
      btnSize = props.size;
    }
  }

  let content;
  if (props.expanded) {
    content = (
      <div className="rsa-loader-spinner expanded">
        <CircularProgress size={btnSize} color={color} classes={{ root: `loading-btn ${props.className || ''}` }} />
      </div>
    );
  } else {
    content = <CircularProgress size={btnSize} color={color} classes={{ root: `rsa-loader-spinner loading-btn ${props.className || ''}` }} />;
  }

  return content;
};

Spinner.defaultProps = {
  size: 'sm',
  expanded: false
};

export default Spinner;
